module.exports = __webpack_public_path__ + "static/fonts/ProximaNovaA-Bold.a67e9258.woff";